import React, { useState } from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { BasicModal } from "./BasicModal/BasicModal";
import { useFirebase } from "../context/ApiContext";

const EmailVerificationModal = ({ open, onClose }) => {
	const { resendVerificationEmail, user } = useFirebase();
	const [sending, setSending] = useState(false);
	const [sent, setSent] = useState(false);

	const handleResend = async () => {
		setSending(true);
		try {
			await resendVerificationEmail();
			setSent(true);
		} catch {
			// silently fail
		} finally {
			setSending(false);
		}
	};

	return (
		<BasicModal
			showModal={open}
			handleClose={onClose}
			width={420}
			contentSx={{
				borderRadius: "20px",
				textAlign: "center",
				p: { xs: 3, sm: 4 },
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					gap: 2.5,
					pt: 1,
				}}
			>
				<Box
					sx={{
						width: 64,
						height: 64,
						borderRadius: "50%",
						background: "linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%)",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<MailOutlineIcon sx={{ fontSize: 32, color: "#d97706" }} />
				</Box>

				<Box>
					<Typography
						sx={{
							fontSize: 19,
							fontWeight: 700,
							color: "#1a1a2e",
							mb: 1,
							fontFamily: "'Inter', sans-serif",
						}}
					>
						Verifica tu email para continuar
					</Typography>
					<Typography
						sx={{
							fontSize: 14,
							color: "#64748b",
							lineHeight: 1.6,
							fontFamily: "'Inter', sans-serif",
						}}
					>
						Hemos enviado un enlace de verificación a{" "}
						<strong style={{ color: "#334155" }}>{user?.email}</strong>.
						Revisa tu bandeja de entrada (y spam) para activar todas las funciones.
					</Typography>
				</Box>

				{sent ? (
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							gap: 1,
							py: 1.5,
							px: 3,
							borderRadius: "12px",
							background: "rgba(16, 185, 129, 0.08)",
							border: "1px solid rgba(16, 185, 129, 0.2)",
						}}
					>
						<CheckCircleIcon sx={{ fontSize: 18, color: "#10B981" }} />
						<Typography
							sx={{
								fontSize: 13,
								fontWeight: 600,
								color: "#065F46",
								fontFamily: "'Inter', sans-serif",
							}}
						>
							Email de verificación reenviado
						</Typography>
					</Box>
				) : (
					<Button
						fullWidth
						onClick={handleResend}
						disabled={sending}
						sx={{
							height: 48,
							borderRadius: "14px",
							background: "linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
							color: "#fff!important",
							textTransform: "none",
							fontWeight: 600,
							fontSize: 14,
							boxShadow: "0 4px 14px rgba(99, 102, 241, 0.35)",
							fontFamily: "'Inter', sans-serif",
							"&:hover": {
								background: "linear-gradient(135deg, #5558E3 0%, #7C4DE8 100%)",
								boxShadow: "0 6px 20px rgba(99, 102, 241, 0.45)",
							},
							"&.Mui-disabled": {
								background: "rgba(99, 102, 241, 0.3)",
								color: "rgba(255,255,255,0.6)",
							},
						}}
					>
						{sending ? (
							<CircularProgress size={20} sx={{ color: "#fff" }} />
						) : (
							"Reenviar email de verificación"
						)}
					</Button>
				)}

				<Button
					onClick={onClose}
					sx={{
						textTransform: "none",
						fontSize: 13,
						color: "#64748b",
						fontFamily: "'Inter', sans-serif",
						"&:hover": { color: "#334155", background: "rgba(0,0,0,0.04)" },
					}}
				>
					Ahora no
				</Button>
			</Box>
		</BasicModal>
	);
};

export default EmailVerificationModal;
